export default __webpack_public_path__ + "static/media/astronaut-mobile.215f9c55.jpg";